/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DashboardPageBlockTableSerieRow = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink);
  }
}(this, function(ApiClient, CorporateStructureLink) {
  'use strict';




  /**
   * The DashboardPageBlockTableSerieRow model module.
   * @module model/DashboardPageBlockTableSerieRow
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DashboardPageBlockTableSerieRow</code>.
   * @alias module:model/DashboardPageBlockTableSerieRow
   * @class
   */
  var exports = function() {
    var _this = this;













  };

  /**
   * Constructs a <code>DashboardPageBlockTableSerieRow</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DashboardPageBlockTableSerieRow} obj Optional instance to populate.
   * @return {module:model/DashboardPageBlockTableSerieRow} The populated <code>DashboardPageBlockTableSerieRow</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('TrackingTargetSystemRegisterID')) {
        obj['TrackingTargetSystemRegisterID'] = ApiClient.convertToType(data['TrackingTargetSystemRegisterID'], 'Integer');
      }
      if (data.hasOwnProperty('BackgroundColor')) {
        obj['BackgroundColor'] = ApiClient.convertToType(data['BackgroundColor'], 'String');
      }
      if (data.hasOwnProperty('BordersVisible')) {
        obj['BordersVisible'] = ApiClient.convertToType(data['BordersVisible'], 'Boolean');
      }
      if (data.hasOwnProperty('IsBold')) {
        obj['IsBold'] = ApiClient.convertToType(data['IsBold'], 'Boolean');
      }
      if (data.hasOwnProperty('HighlightNegative')) {
        obj['HighlightNegative'] = ApiClient.convertToType(data['HighlightNegative'], 'Boolean');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('Hidden')) {
        obj['Hidden'] = ApiClient.convertToType(data['Hidden'], 'Boolean');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('IndicatorID')) {
        obj['IndicatorID'] = ApiClient.convertToType(data['IndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
      if (data.hasOwnProperty('BlockID')) {
        obj['BlockID'] = ApiClient.convertToType(data['BlockID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} TrackingTargetSystemRegisterID
   */
  exports.prototype['TrackingTargetSystemRegisterID'] = undefined;
  /**
   * @member {String} BackgroundColor
   * @default ''
   */
  exports.prototype['BackgroundColor'] = '';
  /**
   * @member {Boolean} BordersVisible
   * @default false
   */
  exports.prototype['BordersVisible'] = false;
  /**
   * @member {Boolean} IsBold
   * @default false
   */
  exports.prototype['IsBold'] = false;
  /**
   * @member {Boolean} HighlightNegative
   * @default false
   */
  exports.prototype['HighlightNegative'] = false;
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Boolean} Hidden
   * @default false
   */
  exports.prototype['Hidden'] = false;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} IndicatorID
   * @default 0
   */
  exports.prototype['IndicatorID'] = 0;
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;
  /**
   * @member {Integer} BlockID
   * @default 0
   */
  exports.prototype['BlockID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


